import {
  CalendarOutlined,
  ClockCircleOutlined,
  InfoCircleOutlined,
  WarningOutlined,
} from "@ant-design/icons";
import { Card, Empty, List, Space, Spin, Tag, Typography } from "antd";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { IPhaseReminder } from "../../models/Research";
import { useGetProjectOverview } from "../../query/ReseachQuery";

const ProjectRemindPhase = () => {
  const { data, isLoading } = useGetProjectOverview();
  const navigate = useNavigate();

  const getStatusTag = (status: "warning" | "caution") => {
    if (status === "warning") {
      return (
        <Tag
          icon={<WarningOutlined />}
          color="error"
          style={{
            borderRadius: "16px",
            fontSize: "12px",
            padding: "2px 12px",
            fontWeight: 500,
          }}
        >
          Khẩn cấp
        </Tag>
      );
    }
    return (
      <Tag
        icon={<InfoCircleOutlined />}
        color="warning"
        style={{
          borderRadius: "16px",
          fontSize: "12px",
          padding: "2px 12px",
          fontWeight: 500,
        }}
      >
        Cảnh báo
      </Tag>
    );
  };

  const getDaysColor = (days: number) => {
    if (days <= 3) return "#ff4d4f";
    if (days <= 7) return "#faad14";
    return "#1890ff";
  };

  if (isLoading) {
    return (
      <Card>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "200px",
          }}
        >
          <Spin size="large" />
        </div>
      </Card>
    );
  }

  if (!data?.reminders || data.reminders.length === 0) {
    return (
      <Card>
        <Empty
          description="Không có giai đoạn nào cần nhắc nhở"
          image={Empty.PRESENTED_IMAGE_SIMPLE}
        />
      </Card>
    );
  }

  return (
    <List
      dataSource={data.reminders}
      renderItem={(item: IPhaseReminder) => (
        <List.Item
          style={{
            padding: "14px",
            borderRadius: "8px",
            marginBottom: "8px",
            background: item.status === "warning" ? "#fff1f0" : "#fffbe6",
            border: `1px solid ${item.status === "warning" ? "#ffccc7" : "#ffe58f"}`,
            cursor: "pointer",
            transition: "all 0.3s",
          }}
          onClick={() => navigate(`/r&d/projects/${item.projectName}`)}
          onMouseEnter={(e) => {
            e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.1)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.boxShadow = "none";
          }}
        >
          <div style={{ width: "100%" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                marginBottom: "8px",
              }}
            >
              <Space direction="vertical" size={4}>
                <Typography.Link
                  strong
                  style={{ fontSize: "15px", color: "#1890ff" }}
                >
                  Dự án: {item.projectName}
                </Typography.Link>
                <Typography.Text style={{ fontSize: "14px", color: "#595959" }}>
                  Giai đoạn: <strong>{item.phaseName}</strong>
                </Typography.Text>
              </Space>
              {getStatusTag(item.status)}
            </div>

            <Space size={24} style={{ marginTop: "8px" }}>
              <Space size={6}>
                <CalendarOutlined style={{ color: "#8c8c8c" }} />
                <Typography.Text style={{ fontSize: "13px", color: "#595959" }}>
                  Hết hạn: {dayjs(item.endDate).format("DD-MM-YYYY")}
                </Typography.Text>
              </Space>
              <Space size={6}>
                <ClockCircleOutlined
                  style={{ color: getDaysColor(item.daysRemaining) }}
                />
                <Typography.Text
                  strong
                  style={{
                    fontSize: "13px",
                    color: getDaysColor(item.daysRemaining),
                  }}
                >
                  Còn {item.daysRemaining} ngày
                </Typography.Text>
              </Space>
            </Space>
          </div>
        </List.Item>
      )}
    />
  );
};

export default ProjectRemindPhase;
